import React from "react";
import { Mail, MapPin } from "lucide-react";
import { COMPANY } from "@/lib/site";

export const HeadOfficeCard = () => (
  <div className="rounded-2xl border border-slate-200 bg-white p-4 shadow-[var(--shadow-md)]">
    <div className="flex items-start gap-3">
      <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[#f28a2e]" aria-hidden="true" />
      <div>
        <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">
          Head office
        </p>
        <p className="mt-1 text-sm font-medium text-[#0b1d3a]">{COMPANY.address.line1}</p>
        <p className="text-sm font-medium text-[#0b1d3a]">
          {COMPANY.address.city} - {COMPANY.address.country}
        </p>
      </div>
    </div>
  </div>
);

export const MobileEmailCard = () => (
  <a
    href={COMPANY.emailLink}
    data-testid="hero-email-link"
    className="flex items-center gap-3 rounded-2xl border border-slate-200 bg-white p-4 shadow-[var(--shadow-md)] transition-colors hover:bg-slate-50 lg:hidden"
  >
    <Mail className="h-4 w-4 text-[#0f6e73]" aria-hidden="true" />
    <span className="text-sm font-medium text-[#0b1d3a]">{COMPANY.email}</span>
  </a>
);

export const ActivityChips = ({ items }) => (
  <ul className="mt-9 flex flex-wrap gap-2" aria-label="Group activities">
    {items.map(({ icon: Icon, label }) => (
      <li
        key={label}
        className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white/80 px-3 py-1.5 text-xs font-medium text-slate-700"
      >
        <Icon className="h-3.5 w-3.5 text-[#0f6e73]" aria-hidden="true" />
        {label}
      </li>
    ))}
  </ul>
);
